import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { styled } from '@mui/material/styles';

import { SidebarStateKey } from 'layout/MainLayout/components/Sidebar/store';

import type { SidebarAnimatedComponentsState } from 'layout/MainLayout/components/Sidebar/types';

const iconSize = 20;

export const Icon = styled(ArrowBackOutlinedIcon, {
  shouldForwardProp: prop => prop !== SidebarStateKey.Opened,
})<SidebarAnimatedComponentsState>(({ opened }) => ({
  width: iconSize,
  height: iconSize,
  transform: `rotate(${opened ? '0' : '180deg'})`,
}));
